import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// Import images
import aboutusImg from '../assets/images/aboutus/aboutus.webp';
import mainSmallImg from '../assets/images/aboutus/main_small.webp';
import mainImg from '../assets/images/aboutus/main.webp';
import mainMoImg from '../assets/images/aboutus/main_mo.webp';
import loversleapImg from '../assets/images/home/loversleap.webp';
import lakeImg from '../assets/images/home/lake.webp';
import moonplainsImg from '../assets/images/home/moonplains.webp';
import golfImg from '../assets/images/home/golf.webp';
import horseImg from '../assets/images/home/horse.webp';
import hakgalaImg from '../assets/images/home/hakgala.webp';
import teaImg from '../assets/images/home/Tea.webp';
import teafactoryImg from '../assets/images/home/teafactory.webp';
import ppmImg from '../assets/images/aboutus/ppm.webp';
import bbkImg from '../assets/images/aboutus/bbk.webp';
import bbmImg from '../assets/images/aboutus/bbm.webp';
import tripadviserLogo from '../assets/images/logo-tripadviser.png';

// Import components
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Add global style to prevent horizontal scrolling
const globalStyle = `
  body {
    overflow-x: hidden;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  .container {
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .row {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }
  
  section {
    overflow-x: hidden;
  }
  
  .swiper-container {
    overflow: hidden;
  }

  .page-header {
    position: relative;
    height: 60vh;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    color: white;
  }

  .page-header .container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .page-header .container h1 {
    width: 100%;
    display: block;
    font-size: 48px;
    font-weight: 300;
    margin-bottom: 10px;
    line-height: 1.2;
    font-family: "Argesta Display";
    text-indent: 130px;
  }

  .page-header .container p {
    font-size: 22建筑物px;
    font-weight: 300;
    margin: 0;
    line-height: 1.5;
    text-indent: 130px;
  }

  .scroll-down {
    position: absolute;
    bottom: 20px;
    width: 2px;
    height: 40px;
    background: white;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    .page-header {
      height: 60vh;
      background-size: cover !important;
      background-position: center;
    }

     .page-header .container h1 {
              font-size: 24px;
              line-height: 1.2;
              text-indent: 45px;
            }

            .page-header .container p {
              font-size: 0.9rem;
              line-height: 1.5;
              text-indent: 45px;
            }
  }
`;

const Kent = () => {
  // Add ref for adventure slider
  const adventureSliderRef = useRef(null);

  useEffect(() => {
    // Inject the global style
    const styleEl = document.createElement('style');
    styleEl.innerHTML = globalStyle;
    document.head.appendChild(styleEl);

    // Add class to body
    document.body.classList.add('example');

    // Implementation of scroll event handler for navbar
    const handleScroll = () => {
      const scroll = window.scrollY;
      const navbar = document.querySelector('.navbarzzz');
      if (navbar) {
        if (scroll > 0) {
          navbar.style.backgroundColor = '#722628';
        } else {
          navbar.style.backgroundColor = 'transparent';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Initialize Swiper for Adventure Slider
    if (adventureSliderRef.current) {
      new Swiper(adventureSliderRef.current, {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 1,
          },
          320: {
            slidesPerView: 1,
          }
        }
      });
    }

    // Clean up
    return () => {
      document.body.classList.remove('example');
      window.removeEventListener('scroll', handleScroll);
      document.head.removeChild(styleEl);
    };
  }, []);

  return (
    <>
     <Helmet>
                        <meta charset="utf-8" />
                        <meta
                          name="viewport"
                          content="width=device-width, initial-scale=1, shrink-to-fit=no"
                        />
                        <meta name="theme-color" content="#722628" />
                        <title>
                        The Kent Cottage | Boutique Hotels and Leisure, Sri Lanka | Oryza
                          Leisure
                        </title>
                        <meta name="author" content="Ollcode" />
                        <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
	                      <meta name="keywords"
		                    content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, vip" />

                      </Helmet>
      <div className="cursor js-cursor"></div>

     
      <Navbar />
      
      <main id="main" style={{ overflow: 'hidden', width: '100%', maxWidth: '100vw' }}>
        <div className="page-header" style={{ backgroundImage: `url(${aboutusImg})`, objectFit: 'contain' }}>
          <div className="container">
            <h1>KENT COTTAGE</h1>
            <p>Stays that delivers endless delights</p>
          </div>
          <div className="scroll-down"></div>
        </div>
        
        <section className="content-section kentbg">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12">
                <div className="section-title text-center whitetext">
                  <h6>A CHIC AND RELAXED CONTEMPORARY LUXURY GETAWAY</h6>
                  <h2>A Symphony of Authenticity and Nature</h2>
                </div>
              </div>
              <div className="col-lg-6 whitetext">
                <p>Warm, refined and relaxing, Kent Cottage has been designed to be a haven of luxury. Enhanced by a team of attentive staff, the atmosphere promises to be gentle and relaxing as the day comes winding down into a frosty night.</p>
                <p>Surrounded by the natural beauty of Nuwara-Eliya, we at Kent Cottage showcase local traditions of hospitality paired with a luxury version of British village style architecture, in truth, the experience couldn't be more unique.</p>
                <p className="paddingrightmo">We strive to offer the best personalized service as a true-to-form boutique hotel, teamed with an exceptional staff and personalized tastes.</p>
              </div>
              <div className="col-xl-4 offset-xl-2 col-lg-5 offset-lg-1 desktopview">
                <div className="testimonial-box bottom">
                  <div className="image">
                    <img src={mainSmallImg} alt="gallery" />
                  </div>
                </div>
              </div>
              <div className="col-12 desktopview">
                <div className="image">
                  <img src={mainImg} alt="gallery" style={{ maxWidth: '100%' }} />
                </div>
              </div>
              <div className="col-12 mobileview">
                <div className="imagetop">
                  <img src={mainMoImg} alt="gallery" style={{ maxWidth: '100%' }} />
                </div>
              </div>
              <div className="clearfix spacing-100 desktopview"></div>
              <div className="clearfix spacing-50 mobileview"></div>
              <div className="col-lg-6">
                <div className="package-box" style={{ background: '#905d5f' }}>
                  <h4>Exclusive Offers</h4>
                  <p>Whether it's the grandeur of a country house, a luxury idyllic hideaway or a romantic retreat,
                    Kent Cottage have special inclusive offers tailor made for you.</p>
                  <Link to="/kent/offers">SEE SPECIAL OFFERS</Link>
                </div>
              </div>
              <div className="clearfix spacing-25 mobileview"></div>
              <div className="col-lg-6">
                <div className="package-box" style={{ background: '#722628' }}>
                  <h4>Gift Vouchers</h4>
                  <p>Give the gift of luxury with Kent Cottage gift vouchers. They can be used as full or
                    part payment for continues to be controlled by
                    accommodation at Kent Cottage.</p>
                  <Link to="/kent/contactus">ENQUIRE GIFT VOUCHERS</Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section" style={{ background: '#905d5f', overflow: 'hidden' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title light">
                  <h6>EXPLORE LOCAL ATTRACTION</h6>
                  <h2>The exclusive door to bespoke expeditions<br />
                    into the Nuwara-Eliya</h2>
                </div>
              </div>
              <div className="col-12">
                <div className="events-tab">
                  <div id="tab01" className="tab-item active-item">
                    <div className="carousel-events-box swiper-container" ref={adventureSliderRef}>
                      <div className="swiper-wrapper">
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={loversleapImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Lover's Leap Waterfall</h5>
                            <span>3KM Away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={lakeImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Lake Gregory</h5>
                            <span>3.6KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={moonplainsImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Moon Plains</h5>
                            <span>4KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={golfImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Nuwara Eliya Golf Club</h5>
                            <span>4.5KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={horseImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Horse riding at<br />Race Course Ground</h5>
                            <span>4.7KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={hakgalaImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Hakgala Botanical Gardens</h5>
                            <span>8KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={teaImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Tea Plantations</h5>
                            <span>All around the location</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={teafactoryImg} alt="gallery" />
                          </figure>
                          <div className="content">
                            <h5>Tea Factory Tours</h5>
                            <span>12.5KM away (closest is Heritance Tea Factory)</span>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-prev"></div>
                      <div className="swiper-next"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section" style={{ background: '#ecdfd7', overflow: 'hidden' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="section-title text-center collection">
                  <h6 style={{ color: '#722628', fontFamily: 'Poppins, sans-serif', opacity: 0.6 }}>
                    OUR LUXURY DESTINATIONS IN SRI LANKA
                  </h6>
                  <h2 style={{ color: '#722628', fontFamily: 'Poppins, sans-serif' }}>
                    Explore Oryza Leisure destinations in <br />Sri Lanka
                  </h2>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="member-box">
                  <figure>
                    <img src={ppmImg} alt="gallery" />
                    <ul>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-facebook-filled"></i></a>
                        </button>
                      </li>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-instagram"></i></a>
                        </button>
                      </li>
                    </ul>
                  </figure>
                  <div className="content" style={{ backgroundColor: '#722628' }}>
                    <div className="desktopview">
                      <Link to="/pettipettimirissa">
                        <h5 style={{ color: '#fff' }}>PETTI PETTI<br />MIRISSA</h5>
                      </Link>
                    </div>
                    <div className="mobileview">
                      <Link to="/pettipettimirissa">
                        <h5 style={{ color: '#fff' }}>PETTI PETTI MIRISSA</h5>
                      </Link>
                    </div>
                    <a style={{ color: '#fff' }} href="tel:+94761407881">+94 76 140 7881</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="member-box">
                  <figure>
                    <img src={bbkImg} alt="gallery" />
                    <ul>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-facebook-filled"></i></a>
                        </button>
                      </li>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-instagram"></i></a>
                        </button>
                      </li>
                    </ul>
                  </figure>
                  <div className="content" style={{ backgroundColor: '#722628' }}>
                    <Link to="/bananabunkskandy">
                      <h5 style={{ color: '#fff' }}>BANANA BUNKS KANDY</h5>
                    </Link>
                    <a style={{ color: '#fff' }} href="tel:+94767008800">+94 76 700 8800</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="member-box">
                  <figure>
                    <img src={bbmImg} alt="gallery" />
                    <ul>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-facebook-filled"></i></a>
                        </button>
                      </li>
                      <li>
                        <button className="link-button" style={{ backgroundColor: 'rgba(114, 38, 40, 0.0)', color: '#fff', borderStyle: 'none' }}>
                          <a href='/kent'><i className="lni lni-instagram"></i></a>
                        </button>
                      </li>
                    </ul>
                  </figure>
                  <div className="content" style={{ backgroundColor: '#722628' }}>
                    <Link to="/bananabunksmirissa">
                      <h5 style={{ color: '#fff' }}>BANANA BUNKS MIRISSA</h5>
                    </Link>
                    <a style={{ color: '#fff' }} href="tel:+94767008800">+94 76 700 8800</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing desktopview" style={{ background: '#905d5f', overflow: 'hidden' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bar">
                  <i className="lni lni-protection"></i>
                  <h6>View our reviews from our previous guest on</h6>
                  <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noopener noreferrer">
                    <strong style={{ color: '#fff' }}>Tripadvisor</strong>
                  </a>
                  <figure>
                    <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noopener noreferrer">
                      <img src={tripadviserLogo} alt="Tripadvisor reviews of Kent Cottage" />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};

export default Kent;